import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-bottom-menu',
  templateUrl: './skeleton-bottom-menu.component.html',
  styleUrls: ['./skeleton-bottom-menu.component.scss']
})
export class SkeletonBottomMenuComponent {

}
